var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoins = function SvgCoins(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgCoins",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgCoins{fill:#B5B5B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cash",
    transform: "translate(-61.419 -62.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    className: "svgCoins svgBase svgHover svgSelect",
    d: "M70.4,71.1c4.3,0,8.8-1.4,8.8-4s-4.6-4-8.8-4s-8.8,1.4-8.8,4S66.1,71.1,70.4,71.1 M70.4,64.7 c4.4,0,7.2,1.4,7.2,2.4s-2.8,2.4-7.2,2.4s-7.2-1.4-7.2-2.4S66,64.7,70.4,64.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    className: "svgCoins svgBase svgHover svgSelect",
    d: "M63.2,70.5c-0.4-0.3-0.9-0.2-1.1,0.2c0,0,0,0,0,0c-0.3,0.4-0.5,0.9-0.5,1.4 c0,1.2,1.1,2.3,2.9,3c1.8,0.6,3.7,0.9,5.6,0.9h0.4c4.3-0.1,8.8-1.6,8.8-4.2c0-0.4-0.1-0.8-0.3-1.1c-0.2-0.4-0.7-0.5-1.1-0.3 c-0.4,0.2-0.5,0.7-0.3,1.1c0.1,0.1,0.1,0.2,0.1,0.3c0,1-2.8,2.5-7.2,2.5c-1.8,0.1-3.7-0.2-5.4-0.8c-1.1-0.4-1.9-1-1.9-1.5 c0-0.2,0.1-0.3,0.2-0.4C63.6,71.3,63.5,70.8,63.2,70.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    className: "svgCoins svgBase svgHover svgSelect",
    d: "M77.7,75.3c-0.4,0.2-0.5,0.7-0.2,1.1c0,0,0,0,0,0c0.1,0.1,0.1,0.2,0.1,0.4c0,1-2.8,2.4-7.2,2.4 s-7.2-1.4-7.2-2.4c0-0.1,0.1-0.3,0.1-0.4c0.2-0.4,0.1-0.9-0.2-1.1c-0.4-0.2-0.9-0.1-1.1,0.2c-0.3,0.4-0.4,0.8-0.4,1.3 c0,2.6,4.5,4,8.8,4s8.8-1.4,8.8-4c0-0.5-0.1-0.9-0.4-1.3C78.6,75.1,78.1,75,77.7,75.3C77.7,75.3,77.7,75.3,77.7,75.3"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoins, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coins.5196b5a6.svg";
export { ForwardRef as ReactComponent };